import { kindNoteEntries } from '../lib/format'

/** Says what a stored reading of a non-instantaneous parameter is.
 *
 *  A lifetime counter is a running total, not the volume over the window,
 *  and precipitation climbs and drops back to zero every day — nothing about
 *  either line makes that obvious. Shared by the MDS explorer and the
 *  instrument page: the same chart can carry one of these kinds on either
 *  screen, and the note is the same note wherever it appears. The instrument
 *  page draws one set per chart, under the chart whose relabelled lines it
 *  names.
 */
export function KindNotes({ series }: {
  series: { parameter: string; display_name: string; kind: string }[]
}) {
  const notes = kindNoteEntries(series)
  if (!notes.length) return null
  return (
    <details className="data-notes">
      <summary>Data notes</summary>
      <ul className="notes">
      {notes.map((entry) => (
        <li key={entry.key}>
          <b>{entry.name}</b>: {entry.note}
        </li>
      ))}
      </ul>
    </details>
  )
}
